import { DocumentData, DocumentSnapshot } from '@angular/fire/firestore';

interface WithId {
  id?: string;
}

export function mapDocToType<T extends WithId>(
  doc: DocumentSnapshot<DocumentData>
): T {
  return { ...doc.data(), id: doc.id } as T;
}

export function mapDocsToType<T extends WithId>(
  docs: DocumentSnapshot<DocumentData>[]
): T[] {
  return docs.map((doc) => mapDocToType<T>(doc));
}
